import { Component, OnInit, ViewChild } from '@angular/core';
import { ResponseData, formBuilder, formBuilderData } from 'src/app/helper/interface/response';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { ModalService } from 'src/app/shared/service/modal.service';
import { AppointmentApiService } from '../../service/appointment-api.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { AlertService } from 'src/app/helper/service/alert.service';
import { Subject } from 'rxjs';
import { ADD_APPOINTMENT } from '../../helper/appointment-form';
import { cloneData } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';

const APPOINTMENT_MONITOR_REFRESH_KEY = 'appointment-monitor-refresh';

@Component({
  selector: 'app-add-appointment',
  templateUrl: './add-appointment.component.html',
  styleUrl: './add-appointment.component.scss'
})
export class AddAppointmentComponent implements OnInit {

  addAppointFormData: formBuilder[] = []
  isModal: boolean = false;
  selectedData: any;
  doctorName: string = ''
  loading: boolean = false;
  public onClose: Subject<boolean> = new Subject();
  pageInfo: pageInfo = {} as pageInfo;
  changeStatusPageInfo: pageInfo = {
    title: 'Change Appointment Status',
  }
  type: 'ADD' | 'RESCHEDULE' | 'CHANGE_STATUS' = 'ADD';
  @ViewChild('addAppointForm') addAppointForm: FormGeneratorComponent | undefined;
  @ViewChild('changeStatusForm') changeStatusForm: FormGeneratorComponent | undefined;

  changeStatusFormData: formBuilderData[] = [
    {
      colName: 'appointment_status_fk_id',
      title: 'Select Status',
      type: 'select',
      apiTblName: 'appointment_status',
      selectKeyName: 'appointment_statusName',
      selectPrimaryKey: 'id',
      validator: [{ name: 'required' }],
      col_size: 12
    }
  ]

  constructor(
    private modalService: ModalService,
    private appointApi: AppointmentApiService,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
    const data = this.selectedData
    this.type = data?.type || 'RESCHEDULE'
    this.addAppointForm?.setData(this.selectedData);
  }

  setInput(data: any) {
    this.isModal = true
    this.selectedData = this.normalizeAppointmentData(data);
    this.type = data?.type || 'ADD'
    if (this.type == 'ADD') {
      this.pageInfo.title = 'Add Appointment'
      this.addAppointFormData = cloneData(ADD_APPOINTMENT).map((a: formBuilder) => { if (a.colName == 'appointment_on') { a.timeOnly = true } return a })
    } else {
      this.pageInfo.title = 'Reschedule Appointment'
      // this.addAppointFormData = cloneData(ADD_APPOINTMENT)
      this.addAppointFormData = [
        ...cloneData(ADD_APPOINTMENT),
        {
          colName: 'reschedule_reason',
          title: 'Reschedule Reason',
          placeholder: 'Enter reschedule reason',
          validator: [{ name: 'required' }],
          type: 'TEXTAREA',
        }
      ];

    }
    setTimeout(() => {
      this.addAppointForm?.setData(this.selectedData);
    }, 800);
    if (this.selectedData?.doctor_fk_id) {
    }

  }

  normalizeAppointmentData(data: any) {
    if (!data) {
      return data;
    }

    const appointmentData = { ...data };
    const appointmentOn = this.resolveAppointmentDateTime(appointmentData);
    if (appointmentOn) {
      appointmentData.appointment_on = appointmentOn;
    }

    return appointmentData;
  }

  resolveAppointmentDateTime(data: any): Date | null {
    if (data?.appointment_on) {
      const date = data.appointment_on instanceof Date ? data.appointment_on : this.parseAppointmentOn(data.appointment_on);
      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    const appointmentDate = data?.appointment_date || data?.appointmentDate;
    if (!appointmentDate) {
      return null;
    }

    const appointmentTime = data?.appointment_time || data?.appointmentTime || '';
    const dateTime = this.parseDateTime(appointmentDate, appointmentTime);
    return isNaN(dateTime.getTime()) ? null : dateTime;
  }

  parseDateTime(dateValue: any, timeValue: any = '') {
    const dateText = String(dateValue).trim();
    const timeText = String(timeValue || '').trim();
    let date = new Date(`${dateText} ${timeText}`.trim());

    if (!isNaN(date.getTime())) {
      return date;
    }

    const dateParts = dateText.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
    if (dateParts) {
      const [, day, month, year] = dateParts;
      date = new Date(+year, +month - 1, +day);
      const timeParts = timeText.match(/^(\d{1,2}):(\d{2})(?:\s*([AP]M))?$/i);
      if (timeParts) {
        let hours = +timeParts[1];
        const minutes = +timeParts[2];
        const meridian = timeParts[3]?.toUpperCase();
        if (meridian == 'PM' && hours < 12) {
          hours += 12;
        }
        if (meridian == 'AM' && hours == 12) {
          hours = 0;
        }
        date.setHours(hours, minutes, 0, 0);
      }
    }

    return date;
  }

  parseAppointmentOn(value: any) {
    const dateText = String(value).trim();
    const dateTimeParts = dateText.match(/^(\d{4}-\d{2}-\d{2})\s+(.+)$/);
    if (dateTimeParts) {
      return this.parseDateTime(dateTimeParts[1], dateTimeParts[2]);
    }

    return new Date(dateText);
  }

  getChangeStatusAppointmentOn() {
    const appointmentOn = this.resolveAppointmentDateTime(this.selectedData);
    if (!appointmentOn) {
      return this.selectedData?.appointment_on;
    }

    const time = this.isMidnightAppointment(this.selectedData, appointmentOn)
      // ? this.formatTimeToAmPm(new Date())
      // : this.getAppointmentTimeText(this.selectedData, appointmentOn);
      ? this.formatTimeToRailway(new Date())
      : this.formatTimeToRailway(appointmentOn);

    return `${this.formatDate(appointmentOn)} ${time}`;
  }

  isMidnightAppointment(data: any, appointmentOn: Date) {
    const appointmentTime = String(data?.appointment_time || data?.appointmentTime || '').trim();

    if (appointmentTime) {
      const timeParts = appointmentTime.match(/^(\d{1,2}):(\d{2})(?:\s*([AP]M))?$/i);
      if (timeParts) {
        const hours = +timeParts[1];
        const minutes = +timeParts[2];
        const meridian = timeParts[3]?.toUpperCase();
        return minutes === 0 && ((meridian === 'AM' && hours === 12) || (!meridian && hours === 0));
      }
    }

    return appointmentOn.getHours() === 0 && appointmentOn.getMinutes() === 0;
  }

  getAppointmentTimeText(data: any, appointmentOn: Date) {
    const appointmentTime = String(data?.appointment_time || data?.appointmentTime || '').trim();
    return appointmentTime || this.formatTimeToAmPm(appointmentOn);
  }

  formatDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatTimeToAmPm(date: Date) {
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const meridian = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, '0')}:${minutes} ${meridian}`;
  }

  formatTimeToRailway(date: Date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}:00`;
  }

  saveAppointment() {
    if (!this.addAppointForm?.isValid()) {
      return
    }
    this.loading = true;
    // const apiFun = this.type == 'ADD' ? 'saveAppointment' : 'rescheduleAppointment';
    this.appointApi.saveAppointment(this.apiPayload()).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.notifyAppointmentMonitorRefresh();
        this.onClose.next(res?.result);
        this.alertService.showToast('Appointment save successfully', 'success')
        this.close();

        window.location.reload();
      }
    })
      .catch(() => { this.alertService.showToast('Unable to Save', 'error'); this.loading = false })
      .finally(() => this.loading = false)
  }

  changeStatus() {
    if (!this.changeStatusForm?.isValid()) {
      return
    }
    this.appointApi.saveAppointment(this.apiPayload()).then((res: ResponseData) => {
      if (res.statusCode === RESPONSE_CODE.SUCCESS) {
        console.log('payload', this.apiPayload())
        this.notifyAppointmentMonitorRefresh();
        this.onClose.next(res?.result);
        this.alertService.showToast('Appointment status updated successfully', 'success')
        this.close();
        window.location.reload();
      }
    })
  }

  apiPayload() {
    const data = this.addAppointForm?.getFormValue() || {};
    const changeStatusData = this.changeStatusForm?.getFormValue() || {};

    console.log('changeStatusData', changeStatusData);
    console.log('data', data);
    console.log('selected data', this.selectedData);

    // Change status case
    if (this.type === 'CHANGE_STATUS') {
      data.id = this.selectedData.id;
      data.appointment_status_fk_id = changeStatusData.appointment_status_fk_id;
      data.appointment_status = changeStatusData.appointment_statusName;
      data.patientName = this.selectedData.patientName;
      data.patient_fk_id = this.selectedData.patient_fk_id || null;
      data.appointment_on = this.getChangeStatusAppointmentOn();
    }

    if (this.selectedData?.id && this.type === 'RESCHEDULE') {
      data.id = this.selectedData.id;
      data.is_reschedule = 1;
      data.appointment_status_fk_id = 4;
    }

    if (data.fname) {
      data.doctorName = data.fname;
      delete data.fname;
    } else if (this.selectedData?.fname) {
      data.doctorName = this.selectedData.fname;
    }

    if (!data.doctor_fk_id && this.selectedData?.doctor_fk_id) {
      data.doctor_fk_id = this.selectedData.doctor_fk_id;
    }

    if (data.patient_fk_id && isNaN(Number(data.patient_fk_id))) {
      data.patientName = data.patient_fk_id;
      data.patient_fk_id = null;
    }

    return data;
  }

  notifyAppointmentMonitorRefresh() {
    localStorage.setItem(APPOINTMENT_MONITOR_REFRESH_KEY, Date.now().toString());
  }

  close() {
    if (this.isModal) {
      this.modalService.close()
    }
  }
}
